import React from 'react';
import { SessionExercise } from '../../types/api';

interface ExerciseListItemProps {
  exercise: SessionExercise;
  index: number;
}

export function ExerciseListItem({ exercise, index }: ExerciseListItemProps) {
  return (
    <div className="p-4 border-b">
      <div className="flex items-center">
        <span className="text-lg font-bold text-gray-500 mr-4">{index + 1}</span>
        <div>
          <h3 className="font-semibold">{exercise.exerciseName}</h3>
          <p className="text-sm text-gray-600">{exercise.notes || "No notes"}</p>
        </div>
      </div>
    </div>
  );
}